import { connect } from 'react-redux'
import { createReservation } from 'registry/actions'
import { createReservation as updateReservation } from 'cart/actions'
import { GroupGiftReserveForm } from './group-gift-reserve-form'

export default connect(null, {
  createReservation,
  updateReservation,
})(GroupGiftReserveForm)
